import { render } from "./transactions.vue?vue&type=template&id=020b40d2"
import script from "./transactions.vue?vue&type=script&lang=js"
export * from "./transactions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__